import { render, staticRenderFns } from "./AddAnotherItem.vue?vue&type=template&id=9fdf49d8&"
import script from "./AddAnotherItem.vue?vue&type=script&lang=js&"
export * from "./AddAnotherItem.vue?vue&type=script&lang=js&"
import style0 from "./AddAnotherItem.vue?vue&type=style&index=0&id=9fdf49d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports